'use client';

import { c as _c } from "react/compiler-runtime";
import { useWebStorageStore } from '@/globals/webStorage/useWebStorage';
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import React from 'react';
import { copyAnchorCSS } from './CopyAnchor.css';
import { store } from '@/sections/editorWidget/EditorWidget.client.loader';
import { copyLinkIcon } from '@/uiIcons/copyLinkIcon.css';
import { icon } from '@/uiPrimitives/media/icon';
import { checkBulletIcon } from '@/uiIcons/checkBulletIcon.css';
import { errorCircleIcon } from '@/uiIcons/errorCircleIcon.css';
import { hasCmsPreview } from '@/globals/config/hasCmsPreview.config';
import { classes } from '@/uiPrimitives/base/classes.helpers';
export const CopyAnchor = t0 => {
  const $ = _c(10);
  const {
    id,
    className
  } = t0;
  const [copied, setCopied] = React.useState("idle");
  const [opened] = useWebStorageStore(store, hasCmsPreview);
  let t1;
  if ($[0] !== id) {
    t1 = async e => {
      e.preventDefault();
      ;
      try {
        await navigator.clipboard.writeText(id);
        setCopied("fulfilled");
      } catch (t2) {
        const error = t2;
        console.error("Failed to copy anchor link:", error);
        setCopied("rejected");
      }
    };
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const abortController = new AbortController();
      document.addEventListener("click", () => {
        setCopied("idle");
      }, {
        signal: abortController.signal
      });
      return () => {
        abortController.abort();
      };
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  React.useEffect(t2, t3);
  let t4;
  if ($[4] !== className || $[5] !== copied || $[6] !== handleCopy || $[7] !== id || $[8] !== opened) {
    t4 = opened ? <DOPLink href={`#${id}`} tabIndex={0} aria-label="Copy anchor link" onClick={handleCopy} data-link-type="copy-anchor-link" className={classes(className, copyAnchorCSS)}>{copied === "fulfilled" && <i className={icon({
        icon: checkBulletIcon,
        fill: "positiveGreen"
      })} />}{copied === "idle" && <i className={icon({
        icon: copyLinkIcon,
        fill: "positiveMuted"
      })} />}{copied === "rejected" && <i className={icon({
        icon: errorCircleIcon,
        fill: "positiveRed"
      })} />}</DOPLink> : null;
    $[4] = className;
    $[5] = copied;
    $[6] = handleCopy;
    $[7] = id;
    $[8] = opened;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};